import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";

  
var optionsCapacidades = [];
var bloquearCampo = true;

class DropDownCellAllProdutoGridsSemContas extends Component {
  state = {
    optionsProdutos: [],
    optionsProdutosFilter: [],
    selectedValue: null, 
  };

  componentDidMount() {
    (async () => {
      const data = {}
      const TipoVasilha = await services.apiCall.requestApi(
          "/Fiscalizacao/GetProdutosSemContaCorrente",
          data,
          "get"
      );

      console.log(TipoVasilha, "TESTEEEEEEEEEEEEEEEEEEEEEE")
      
      TipoVasilha.map((tipo) => (
        optionsCapacidades.push({text: tipo.desproduto, value: tipo.idproduto})
      ));

      this.setState({ 
        optionsProdutos: optionsCapacidades,
      });

    })();
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });
  }

  static BlockFieldSemConta(valorOutro){
    if(valorOutro == "ProdutosSemConta"){
      bloquearCampo = false;
    }else{
      bloquearCampo = true;
    }
  }


  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    if(dataItem.ProdutosSemConta != undefined && dataItem.ProdutosSemConta != null && optionsCapacidades.length> 0){
      var dataEnter = optionsCapacidades.find(c => c.value === (dataItem.ProdutosSemConta.value))
    }

    if(bloquearCampo == false){
      return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={optionsCapacidades.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={optionsCapacidades}
              textField="text"
              id='id-DropdownCellProdutosSemConta'
            />
            : dataValue != null && dataValue != "" ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined}
        </td>
      );
    }else{
      const dataValue = '';

      return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={null}
              data={optionsCapacidades}
              textField="text"
              id='id-DropdownCellProdutosSemConta'
              disabled
            />
            : dataValue != null && dataValue != ""  ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined}
        </td>
    );
    }
    
  }
    
}

export default DropDownCellAllProdutoGridsSemContas;